import { injectScriptWithIframe, injectStyles } from '@shared/extension/utils/inject-script';
import { ContentScriptStore } from '../store';
import { startHandlingAppActions } from './app-actions';
import { startHandlingServiceWorkerActions } from './service-worker-actions';

export function handleDomContentLoaded(): void {
  if (document.readyState !== 'loading') {
    onDomContentLoaded();
  } else {
    document.addEventListener('DOMContentLoaded', onDomContentLoaded);
  }
}

function onDomContentLoaded(): void {
  const store = ContentScriptStore.getInstance();
  injectScriptWithIframe(
    'body',
    ['notifications/polyfills.js', 'notifications/runtime.js', 'notifications/main.js'].map((path: string) =>
      chrome.runtime.getURL(path)
    ),
    [chrome.runtime.getURL('styles.css')],
    { env: JSON.stringify({ ...process.env, USER_EMAIL: store.profileEmail$.value }) },
  );

  startHandlingAppActions();
  startHandlingServiceWorkerActions(store);
}
